import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AskHrService } from './services/ask-hr.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MessageAction } from './models/message-action.model';
import { BOT_PERSONALITIES, BOT_PREDEFINED_QUESTIONS, COMPONENT_NAME, DONNA_MESSAGE, DONNA_PREDEFINED_BTNS, EVENT_TYPE } from './constants/message.constants';
import { DomSanitizer } from '@angular/platform-browser';
import { SVG_ICONS } from './constants/svg-icons.constants';
import { Subscription, first } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { base64ToString, generateGuid, isEmptyString, isNullOrUndefined, randomIntFromInterval } from './submodules/shared/utils';
import { Answer, Item, RatingRequest } from './models';
import { CollectorOptions, TriggerPosition } from 'ngx-jira-issue-collector';
import { environment } from '@environments/environment';
import { MetricsService } from './services/metrics.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('fadeOutTrigger', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible => hidden', animate('0.5s ease-in-out')),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChildren("answersContainer")  answersContainer!: QueryList<ElementRef>;
  private subscriptions: Subscription[] = [];

  config: CollectorOptions = {
    baseUrl: environment.jiraBaseUrl,
    collectorId: environment.jiraCollectorId,
    triggerPosition: TriggerPosition.CUSTOM
  };

  constructor(private askHrService: AskHrService,
    private metricsService: MetricsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer) {
    this.donnaIcon = sanitizer.bypassSecurityTrustHtml(SVG_ICONS.DONNA_ICON);
  }
  

  readonly COMPONENT_NAME = COMPONENT_NAME;

  private userIdentity: string = 'YW5vbnltb3Vz';
  private userIdentityEmail: string = '';
  avatarLabel: string = 'U';

  private sessionId: string = '';
  private dialogId: string = '';

  botPersonlity: any;
  chatMessages: Item[] = [];
  inputValue: string = '';
  isInputDisabled: boolean = true;
  isAnswerReceived: boolean = false;
  isUserSatisfiedWithAnswer: boolean | null = null;
  hasUserBeenSentEmail: boolean = false;
  ratingSent: boolean = false;
  ratingCancelled: boolean = false;
  showSendToHRPrompt = false;
  rating: number = 0;
  loading: boolean = false;
  comment: string = '';

  isStarRatingDisabled = false;
  fadeOutState = 'visible';
  answers: Answer[] = [];
  userQuery: string = '';
  botAnswer: string = '';

  usersInput: string = '';
  donnaIcon: any;

  showUserPrompt: boolean = false;
  disableUserPrompt: boolean = false;
  userPromptConfirmButton:{ text: string; action: { type: string; value: boolean; data?: any } } | undefined;
  userPromptCancleButton:{ text: string; action: { type: string; value: boolean; data?: any } } | undefined;

  disableRatingPrompt: boolean = false;

  showHelpfullMessages: boolean = false;
  helpfullMessages = BOT_PREDEFINED_QUESTIONS;

  ngOnInit(): void {
    this.botPersonlity = BOT_PERSONALITIES[0];

    this.sessionId = generateGuid(); // generate initialy session ID

    this.subscriptions.push(
      this.activatedRoute.queryParams.subscribe(x => {
        if (!isNullOrUndefined(x['identity'])) {
          this.userIdentity = x['identity'];

          if (!isNullOrUndefined(this.userIdentity) && !isEmptyString(this.userIdentity)) {
            this.userIdentityEmail = base64ToString(this.userIdentity);
            this.loadIdentityData();
          }

          this.showHelpfullMessages = true;
          this.startConversation();
        }
      })
    )
  }

  ngAfterViewChecked(): void {
    this.scrollToElement();
  }

  scrollToElement(): void {
    const element = this.answersContainer.toArray()
    .filter(r => r.nativeElement.hasAttribute('isLatest'))[0]
    element?.nativeElement.scrollIntoView();
    if (element) {
      element.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  startConversation() {
    this.dialogId = generateGuid(); // start new dialog
    this.chatMessages = [];
    this.isInputDisabled = false;
    this.disableRatingPrompt = false;
    this.disableUserPrompt = false;
    this.chatMessages.push({
      isQuestion: false,
      text: DONNA_MESSAGE.INTRODUCTORY_TEXT(this.botPersonlity.name),
      type: COMPONENT_NAME.ANSWER
    });

    this.metricsService.startConversation({ dialogueId: this.dialogId, sessionId: this.sessionId, identity: this.userIdentity });
  }

  askNewQuestion(){
    this.dialogId = generateGuid(); // start new dialog
    this.isInputDisabled = false;
    this.disableRatingPrompt = false;
    this.disableUserPrompt = false;

    this.metricsService.startConversation({ dialogueId: this.dialogId, sessionId: this.sessionId, identity: this.userIdentity });
  }

  sendPredefinedMessage(message: string){    
    this.showHelpfullMessages = false;
    this.sendMessage(message);
  }

  onKey(event: any) {
    if (this.isOnlyWhitespace(this.inputValue)) {
      return;
    }
    //this.showHelpfullMessages = false;
  }

  onEnterKey(event: any) {
    if (this.isOnlyWhitespace(this.inputValue)) {
      return;
    }
    this.showHelpfullMessages = false;
    this.sendMessage(this.inputValue);
  }

  sendMessage(message: string){
    this.inputValue = message;
    this.usersInput = this.inputValue;
    this.chatMessages.push({
      isQuestion: true,
      text: this.usersInput,
      type: "question"
    });

    this.chatMessages.push({
      text: '',
      isQuestion: false,
      type: COMPONENT_NAME.LOADER
    });

    this.loading = true;
    this.isInputDisabled = true;
    this.inputValue = '';

    this.metricsService.questionAsked({ dialogueId: this.dialogId, sessionId: this.sessionId, question: this.usersInput });

    this.askHrService.proccessMessage(this.usersInput).subscribe((x: Answer) => {
      this.usersInput = '';
      this.chatMessages.pop(); // remove the ... message

      this.loading = false;

      let fileName: string = '';
      let finalAnswer: string = '';
      this.scrollToElement();
      if (x.found) {
        if(!x.answerWithoutFile) {
          finalAnswer = `${x.answer}\n\nYou can find the details on <b>Page ${x.pageNumber}</b> of <a href='${x.fileUrl}#page=${x.pageNumber}' target='_blank'>${x.fileName}</a>`;
        } else {
          finalAnswer = x.answer;
        }
        
        this.chatMessages.push({ text: finalAnswer, isQuestion: false, type: COMPONENT_NAME.ANSWER });
        this.chatMessages.push({ text: DONNA_MESSAGE.WAS_INFORMATION_HELPFUL, isQuestion: false, type: COMPONENT_NAME.HELPFUL_INFORMATION });

        this.metricsService.questionAnswered({ dialogueId: this.dialogId, sessionId: this.sessionId, answer: finalAnswer });

        this.showUserPrompt = true;
        this.userPromptConfirmButton = { text: DONNA_PREDEFINED_BTNS.HELPFUL, action: { type: EVENT_TYPE.SATISFACTION_VALUE, value: true }}
        this.userPromptCancleButton = { text: DONNA_PREDEFINED_BTNS.NOT_HELPFUL, action: { type: EVENT_TYPE.SATISFACTION_VALUE, value: false }}
      }
      else {
        this.chatMessages.push({
          isQuestion: false,
          text: x.answer,
          type: COMPONENT_NAME.ANSWER
        });
        this.isInputDisabled = false;
        if(x.isDefaultGreeting){
          this.metricsService.greetingsSend({ dialogueId: this.dialogId, sessionId: this.sessionId });
        } else if (x.isDefaultAnswer){
          this.metricsService.questionFailed({ dialogueId: this.dialogId, sessionId: this.sessionId });

          this.isInputDisabled = true;
          this.startSendToHrProccess(DONNA_MESSAGE.WOULD_YOU_LIKE_TO_SEND_TO_HR);
        } else {
          this.metricsService.questionAnswered({ dialogueId: this.dialogId, sessionId: this.sessionId, answer: x.answer })
        }
      }
    });
    this.scrollToElement();
  }

  onSatisfiedClick() {

    this.chatMessages.push({
      text: DONNA_MESSAGE.GREAT_TO_HEAR,
      isQuestion: false,
      type: COMPONENT_NAME.SEND_EMAIL
    });

    this.metricsService.answerWasHelpful({ dialogueId: this.dialogId, sessionId: this.sessionId });
    
    this.showUserPrompt = true;
    this.userPromptConfirmButton = { text: DONNA_PREDEFINED_BTNS.SEND_COPY, action: { type: EVENT_TYPE.SHOULD_SEND_EMAIL, value: true }}
    this.userPromptCancleButton = { text: DONNA_PREDEFINED_BTNS.NOT_SEND_COPY, action: { type: EVENT_TYPE.SHOULD_SEND_EMAIL, value: false }}
  }

  onNotSatisfiedClick() {
    this.metricsService.answerWasNotHelpful({ dialogueId: this.dialogId, sessionId: this.sessionId });
    this.startSendToHrProccess(DONNA_MESSAGE.APOLOGIZE);
  }

  onSendEmail() {
    const answerIndex = this.chatMessages.slice().reverse().findIndex(item => item.type === 'answer');
    this.botAnswer = (answerIndex !== -1) ? this.chatMessages[this.chatMessages.length - answerIndex - 1].text : '';

    let data = {
      identity: this.userIdentity,
      answer: this.botAnswer,
      question: null
    };
    let sendEmailSubscribtion = this.askHrService.sendEmail(data).subscribe((x: any) => {
      this.chatMessages.push({
        text: DONNA_MESSAGE.INFORMATION_SENT_TO_EMAIL,
        isQuestion:
          false, type: COMPONENT_NAME.ANSWER
      });

      this.metricsService.emailSentToUser({ dialogueId: this.dialogId, sessionId: this.sessionId });
      this.startRating();
      sendEmailSubscribtion.unsubscribe();
    });
  }

  onSendHrEmail() {
    const userQuestions = this.chatMessages.filter(x => x.type === 'question' && x.isQuestion);
    if (userQuestions.length > 0) {
       this.userQuery = userQuestions[userQuestions.length - 1].text;
    } 
    const answerIndex = this.chatMessages.slice().reverse().findIndex(item => item.type === 'answer');
    this.botAnswer = (answerIndex !== -1) ? this.chatMessages[this.chatMessages.length - answerIndex - 1].text : '';
    let data = {
      identity: this.userIdentity,
      answer: this.botAnswer,
      question: this.userQuery
    };
      let sendEmailSubscribtion = this.askHrService.sendHrEmail(data).subscribe((x: any) => {
      this.chatMessages.push({
        text: DONNA_MESSAGE.QUESTION_SENT_TO_HR,
        isQuestion:
          false, type: COMPONENT_NAME.ANSWER
      });

      this.metricsService.sentToHr({ dialogueId: this.dialogId, sessionId: this.sessionId });
      this.startRating();
      sendEmailSubscribtion.unsubscribe();
    });
  }

  onNotSendCopyToEmail() {
    this.chatMessages.push({
      text: DONNA_MESSAGE.I_COMPLETELY_UNDERSTAND,
      isQuestion: false,
      type: COMPONENT_NAME.ANSWER
    });
    this.metricsService.notSentToUser({ dialogueId: this.dialogId, sessionId: this.sessionId });
    this.startRating();
  }

  onCompletedRating(data: { rating: number, comment: string }) {
    var ratingMessageIndex = this.chatMessages.findIndex(x => x.type == COMPONENT_NAME.STAR_RATING);
    this.chatMessages.splice(ratingMessageIndex,1);
    this.chatMessages.push({
      text: DONNA_MESSAGE.THANK_YOU_FOR_SHARING,
      isQuestion: false,
      type: COMPONENT_NAME.NEW_CONVERSATION
    });
   
    this.metricsService.questionRated({ dialogueId: this.dialogId, sessionId: this.sessionId, rating: data.rating, comment: data.comment });
    this.askNewQuestion();
  }

  onUserCancelRating() {
    this.chatMessages.push({
      text: DONNA_MESSAGE.THANK_YOU_FOR_USING,
      isQuestion: false,
      type: COMPONENT_NAME.NEW_CONVERSATION
    });

    this.disableRatingPrompt = true;
    this.showUserPrompt = true;
    this.userPromptConfirmButton = { text: DONNA_PREDEFINED_BTNS.NEW_CONVERSATION, action: { type: EVENT_TYPE.SHOULD_START_NEW_CONVERSATION, value: true }}
    this.userPromptCancleButton = undefined;
  }

  onRefuseToSendToHR() {
    this.chatMessages.push({
      text: DONNA_MESSAGE.I_COMPLETELY_UNDERSTAND,
      isQuestion: false,
      type: COMPONENT_NAME.ANSWER
    });
    this.metricsService.notSentToHr({ dialogueId: this.dialogId, sessionId: this.sessionId });
    this.startRating();
  }

  isOnlyWhitespace(input: string): boolean {
    const regex = /^[\s]*$/;
    return regex.test(input);
  }

  // Alex is here
  handleMessageAction($event: MessageAction) {
    this.showUserPrompt = false;
    if ($event.type === EVENT_TYPE.SATISFACTION_VALUE) {
      if ($event.value) {
        this.onSatisfiedClick(); // done
      } else {
        this.onNotSatisfiedClick(); // done 
      }
    }
    else if ($event.type === EVENT_TYPE.SHOULD_SEND_EMAIL) {
      if ($event.value) {
        this.onSendEmail(); // done
      } else {
        this.onNotSendCopyToEmail(); // done
      }
    }
    else if ($event.type === EVENT_TYPE.SHOULD_SEND_HR) {
      if ($event.value) {
        this.onSendHrEmail(); // done
      } else {
        this.onRefuseToSendToHR(); // done
      }
    }
    else if ($event.type === EVENT_TYPE.RATE_EXPERIENCE) {
      if ($event.value) {
        this.onCompletedRating({rating: this.rating, comment:this.comment});
      } else {
        this.onUserCancelRating();
      }
    }
    else if ($event.type === EVENT_TYPE.SHOULD_START_NEW_CONVERSATION) {
      this.startConversation();
    }
    else if ($event.type === EVENT_TYPE.ASK_NEW_QUESTION) {
      this.askNewQuestion();
    }
  }

  loadIdentityData() {
    let userNames = this.userIdentityEmail.split('@')[0];
    let nameItems = userNames.split('.');
    this.avatarLabel = `${nameItems[0][0].toUpperCase()}${nameItems.reverse()[0][0].toUpperCase()}`;
  }

  handleUserPromptChoise(button: { text: string; action: { type: string; value: boolean; data?: any } }) {
    this.usersInput = button.text;
    this.chatMessages.push({
      isQuestion: true,
      text: this.usersInput,
      type: COMPONENT_NAME.PREDEFINED_BUTTONS
    });

    this.handleMessageAction(button.action)
  }

  handleRatingChange(rating: RatingRequest) {
    this.rating = rating.rating;
    this.comment = rating.comment;
    
    if (this.rating > 0) {
      this.disableUserPrompt = false;
    } else {
      this.disableUserPrompt = true;
    }
  }

  startRating(): void {
    this.chatMessages.push({
      text: DONNA_MESSAGE.RATE_EXPERIENCE,
      isQuestion: false,
      type: COMPONENT_NAME.STAR_RATING
    });
  
    this.showUserPrompt = true;
    this.disableUserPrompt = true;
    this.userPromptConfirmButton = undefined;
    this.userPromptCancleButton = { text: DONNA_PREDEFINED_BTNS.RATE_AND_ASK_NEW, action: { type: EVENT_TYPE.RATE_EXPERIENCE, value: true, data: { rating: this.rating, comment: this.comment } }}
  }

  startSendToHrProccess(message: string) {
    this.chatMessages.push({
      text: message,
      isQuestion: false,
      type: COMPONENT_NAME.SEND_HR
    });

    this.showUserPrompt = true;
    this.userPromptConfirmButton = { text: DONNA_PREDEFINED_BTNS.SEND_TO_HR, action: { type: EVENT_TYPE.SHOULD_SEND_HR, value: true }}
    this.userPromptCancleButton = { text: DONNA_PREDEFINED_BTNS.NOT_SEND_TO_HR, action: { type: EVENT_TYPE.SHOULD_SEND_HR, value: false }}
  }
  
  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }
}